import Component from './Operator.vue';

export default {
  install(Vue) {
    Vue.component('BkfIconOperator', Component);
  },
};
